
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
const faqs = [
    {
        question: "Do you charge any visiting or inspection fees?",
        answer:
            "No, we do not charge any visiting or inspection fees. Our expert will visit your location, assess the situation, and only charge if you decide to proceed with the service.",
    },
    {
        question: "How quickly can I get a home visit after booking?",
        answer:
            "We aim to arrange a home visit within 60–120 minutes after your booking confirmation. Timings may vary depending on your location and traffic conditions.",
    },
    {
        question: "Which areas do you provide doorstep service in?",
        answer:
            "We offer convenient doorstep service across Delhi, Noida, Gurgaon, Ghaziabad, and Faridabad.",
    },
    {
        question: "What if I don’t want to continue after the visit?",
        answer:
            "No problem at all! Our home visits and initial checks are completely free, and there’s no obligation to proceed if you choose not to.",
    },
    {
        question: "Do your services come with any warranty?",
        answer:
            "Yes, we provide up to 12 months of service warranty depending on the type of work completed or the parts provided.",
    },
    {
        question: "Can I get same-day service?",
        answer:
            "For most common services and upgrades, we aim to complete the work on the same day, whenever possible.",
    },
    {
        question: "Can I speak with someone before making a booking?",
        answer:
            "Of course! You can call us directly at 8178052636 or chat with us on WhatsApp using the button below. We’re happy to answer any questions you have.",
    },
];


const BookFAQ = () => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (_event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <section id="faqs" className="bg-gray-950 text-yellow-400 py-16 px-4">
            <div className="max-w-4xl mx-auto text-center mb-10">
                <h2 className="text-4xl font-bold mb-4">Frequently Asked Questions</h2>
                <p className="text-lg text-gray-300">
                    Clear answers to the most common service-related questions
                </p>
            </div>

            <div className="max-w-5xl mx-auto">
                {faqs.map((faq, i) => (
                    <Accordion
                        key={i}
                        expanded={expanded === i}
                        onChange={handleChange(i)}
                        className="!bg-gray-900 !text-gray-300 !border !border-white/10 !rounded-xl mb-4"
                        sx={{
                            "& .MuiAccordionSummary-root": {
                                color: "inherit",
                            },
                            "& .MuiAccordionDetails-root": {
                                color: "#D1D5DB", // Tailwind's gray-300
                            },
                            "& .MuiSvgIcon-root": {
                                color: "#FACC15", // Tailwind's yellow-400
                            },
                        }}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <span className="text-lg font-semibold">{faq.question}</span>
                        </AccordionSummary>
                        <AccordionDetails>
                            <p className="text-sm sm:text-base md:text-base lg:text-base xl:text-base leading-relaxed">
                                {faq.answer}
                            </p>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </div>
        </section>
    );
};

export default BookFAQ;
